import React, { useEffect, useState } from "react";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

export const SHOWREEL_VIDEOS = [
    { id: "tlglz3YPgfM", label: "WiseCursor showreel video 1" },
    { id: "nFTSpCMkokw", label: "WiseCursor showreel video 2" },
];

const ShowreelVideoSlideshow = () => {
    const [activeVideo, setActiveVideo] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const [reduceMotion, setReduceMotion] = useState(false);

    useEffect(() => {
        const query = window.matchMedia?.("(prefers-reduced-motion: reduce)");
        if (!query) return undefined;
        const updatePreference = () => setReduceMotion(query.matches);
        updatePreference();
        query.addEventListener?.("change", updatePreference);
        return () => query.removeEventListener?.("change", updatePreference);
    }, []);

    useEffect(() => {
        if (isPaused || reduceMotion) return undefined;
        const interval = window.setInterval(() => {
            setActiveVideo((current) => (current + 1) % SHOWREEL_VIDEOS.length);
        }, 45000);
        return () => window.clearInterval(interval);
    }, [isPaused, reduceMotion]);

    const selectVideo = (index) => setActiveVideo((index + SHOWREEL_VIDEOS.length) % SHOWREEL_VIDEOS.length);
    const video = SHOWREEL_VIDEOS[activeVideo];

    return (
        <>
            <div aria-hidden="true" className="home-page__showreel-video">
                <iframe
                    allow="autoplay; encrypted-media; picture-in-picture"
                    key={video.id}
                    src={`https://www.youtube-nocookie.com/embed/${video.id}?autoplay=1&mute=1&controls=0&loop=1&playlist=${video.id}&playsinline=1&rel=0`}
                    tabIndex="-1"
                    title="Decorative WiseCursor showreel background"
                />
            </div>
            <div className="home-page__showreel-controls" aria-label="Showreel video controls">
                <button aria-label="Previous showreel video" onClick={() => selectVideo(activeVideo - 1)} type="button"><ChevronLeftRoundedIcon /></button>
                <div className="home-page__showreel-dots" aria-label="Choose showreel video" role="group">
                    {SHOWREEL_VIDEOS.map((item, index) => (
                        <button aria-current={index === activeVideo ? "true" : undefined} aria-label={`Show video ${index + 1}`} className={index === activeVideo ? "is-active" : ""} key={item.id} onClick={() => selectVideo(index)} type="button" />
                    ))}
                </div>
                {!reduceMotion && <button aria-label={isPaused ? "Play showreel slideshow" : "Pause showreel slideshow"} aria-pressed={isPaused} onClick={() => setIsPaused((value) => !value)} type="button">{isPaused ? <PlayArrowRoundedIcon /> : <PauseRoundedIcon />}</button>}
                <button aria-label="Next showreel video" onClick={() => selectVideo(activeVideo + 1)} type="button"><ChevronRightRoundedIcon /></button>
            </div>
        </>
    );
};

export default ShowreelVideoSlideshow;
